<template>
    <div id="app">

        <div v-if="isLoading" id="loading">

        </div>

   <div v-cloak v-else>
            <div v-if="!onLine" class="alert alert-danger" role="alert" style="margin-bottom:0px;">
                Non sei connesso ad Internet.
            </div>


            <router-view :key="$route.fullPath"/>
        </div>

    </div>
</template>

<script>

  export default {
    name: 'App',
    components: {},
    data: function () {
      return {
        isLoading:true,
        onLine: navigator.onLine,
        showBackOnline: false,
        key: '',
        status: {
          sidebarOpen: false
        }
      }
    },
    watch: {
      onLine (v) {
        if (v) {
          this.showBackOnline = true
          setTimeout(() => { this.showBackOnline = false }, 1000)
        }
      }
    },
    methods: {
      updateOnlineStatus (e) {
        const {type} = e
        this.onLine = type === 'online'
      },
      logout: function () {
        this.$cookies.remove('user')
        this.$cookies.remove('token')
        this.$router.push({name: 'login'})
      }
    },
    created(){

    },
    mounted () {
      window.addEventListener('online', this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)
      this.isLoading = false;
    },
    computed: {
      isLoginUrl () {
        return this.$route.fullPath == '/login' || this.$route.fullPath == '/register' || this.$route.fullPath == '/register/success' || this.$route.fullPath == '/register/confirmed'
      },
      isProfileRoute () {
        return this.$route.path.includes('/profile/')
      }
    },
    beforeDestroy () {
      window.removeEventListener('online', this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    }
  }
</script>


<style>
    body, html {
        height: 100%;
    }

    #app {
        height: 100%;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    #nav {
        padding: 30px;
    }

    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    #nav a.router-link-exact-active {
        color: #42b983;
    }
    .list-group-item{
        background:#222939 !important;
    }
    .router-link-active{
        background:#399 !important
    }
</style>
